
import { Injectable } from '@angular/core';
import { AskResponseGpt, DetailsResponse, GetDocumentResponse } from '../domain/models/gpt';
import { IChatbotManage } from '../domain/ports/i-chatbot-manage';
import { AdapterService } from './chatbot-adapter.service';

@Injectable()
export class ChatbotManage implements IChatbotManage {
  constructor(private adapter: AdapterService) { }

  async askGpt(query: string, conversationId?: string, userId?: number, theme?: string, questionType?: 'Retry' | 'Edit' | 'Original'): Promise<AskResponseGpt> {
    const body = {
      conversation_id: conversationId || "",
      query,
      userId: userId,
      theme: theme,
      question_type: questionType
    };

    return this.adapter.askGpt(body).toPromise();
  }

  async downloadDocument(documentName: string): Promise<DetailsResponse<GetDocumentResponse>> {
    const body = {
      FileName: documentName,
      name: "",
      Thread: "",
      Line: "",
      User: "",
      time_zone: ""
    };

    return this.adapter.downloadDocument(body).toPromise();
  }

  async getHistory(userId: number, pageNumber: number = 1, pageSize: number = 10, useCache: boolean = false, search: string = ""): Promise<any> {
    const body = {
      UserId: userId,
      PageNumber: pageNumber,
      PageSize: pageSize,
      UseCache: useCache,
      Search: search
    };

    return this.adapter.getHistory(body).toPromise();
  }

  async getConversation(conversationId: string): Promise<any> {
    const body = {
      conversation_id: conversationId
    }

    return this.adapter.getConversation(body).toPromise();
  }

  async updateConversation(conversationId: string, userId: number, rename: string, pinned: boolean, deleted: boolean): Promise<any> {
    const body = {
      ConversationId: conversationId,
      UserId: userId,
      Rename: rename,
      Pinned: pinned,
      Deleted: deleted
    };
    return this.adapter.updateConversation(body).toPromise();
  }

  async rateAnswer(userId: number,conversationId: string, interactionIndex: string, action: 'like' | 'dislike', comment: string = ''): Promise<any> {
    const body = {
      conversation_id: conversationId,
      interaction_index: interactionIndex,
      action: action,
      comment: comment,
      userId: userId
    };

    return this.adapter.rateAnswer(body).toPromise();
  }

  async createComment(userId: number, comment: string): Promise<any> {
    const body = { UserId: userId, Comment: comment };
    
    return this.adapter.createComment(body).toPromise();
  }
  
  async exportConversationToPdf(conversationId: string): Promise<Blob> {
    const body = {
      conversation_id: conversationId
    }
    return this.adapter.exportConversationToPdf(body).toPromise() as Promise<Blob>;
  }

  async shareConversation(conversationId: string, emails: string[], mailContent: string, subject: string): Promise<any> {
    const body = {
      conversation_id: conversationId,
      recipient_emails: emails,
      message: mailContent,
      subject: subject
    }
    return this.adapter.shareConversation(body).toPromise() as Promise<any>;
  }
}